var map = {
	"./en-US": "M/PE",
	"./en-US.js": "M/PE",
	"./es-419": "vyxh",
	"./es-419.js": "vyxh",
	"./es-CO": "zPZv",
	"./es-CO.js": "zPZv",
	"./es-MX": "Xsu0",
	"./es-MX.js": "Xsu0",
	"./ja-JP": "vyYM",
	"./ja-JP.js": "vyYM",
	"./pt-BR": "3bEq",
	"./pt-BR.js": "3bEq",
	"./zh-CN": "I6ji",
	"./zh-CN.js": "I6ji"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Vxe1";